import { gql } from "@apollo/client";
import CompanyPlanFields from "~/lib/queries/fragments/CompanyPlanFields";
import { ProjectCardFieldsFragment } from "@govlaunch/project";

export default gql`
  fragment VendorFields on Company {
    _id
    logo
    slug
    name
    billingName
    logo
    description
    yearFounded
    createdAt
    businessEmail
    site
    viewerIsMember
    isDisruptor
    address
    contactPage
    highlights
    viewerCanInviteMembers
    viewerCanRemoveMembers
    slogan
    headquarters
    numberOfEmployees
    productsCount
    membersCount
    projectsCount
    feedCount
    highlightsCount
    newsworthyCount
    usersCanAccessAccountPage
    usersCanRequestContentTranslation
    plan {
      ...CompanyPlanFields
    }
    socialMedia {
      linkedin
      twitter
      facebook
      instagram
      youtube
    }
    newsworthy {
      description
      title
      favicon
      siteName
      url
    }
    products {
      _id
      status
      slug
      logo
      name
      description
      link
      governmentsUsingCount
      projectsUsingCount
      isDisruptor
      enrichedProfile
    }
    cover {
      original
      repositioned
    }
    members {
      _id
      slug
      role
      firstName
      fullName
      jobTitle
      avatar
    }
    relatedProjects {
      _id
      ...ProjectCardFields
    }
    pendingProductStackRequests {
      _id
      product {
        _id
        name
        slug
        logo
      }
      government {
        _id
        slug
        logo
        name
        budget
        currency
        isInnovator
        city {
          _id
          name
          population
          country
          countryName
        }
      }
      createdAt
    }
    groups {
      _id
      name
      slug
      logo
      location
      website
      viewerCanDelete
      viewerCanEdit
      viewerIsOwner
    }
    actions {
      _id
      group {
        _id
        slug
        name
        logo
      }
      inviter {
        ... on PendingUser {
          _id
          slug
          fullName
          avatar
        }
        ... on VendorUser {
          _id
          slug
          fullName
          avatar
        }
        ... on GovernmentUser {
          _id
          slug
          fullName
          avatar
        }
      }
      createdAt
    }
    actionsCount
    storiesCount
    governmentConnectionsCount
    governmentConnections(limit: 4) {
      items {
        _id
        slug
        logo
        name
        budget
        currency
        isInnovator
        city {
          _id
          name
          population
          country
          countryName
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
    resources {
      ... on LinkResource {
        url
        title
        addedAt
      }
      ... on DownloadResource {
        url
        title
        filename
        addedAt
      }
      ... on TextResource {
        title
        body
        addedAt
      }
    }
    enabledSharing
    sharing {
      stories
      projects
      products
      resources
      groups
      governments
      newsworthy
      highlights
      team
    }
    sponsorships {
      name
      logo
      link
    }
  }

  ${CompanyPlanFields}
  ${ProjectCardFieldsFragment}
`;
